import { environment } from '../../../../environments/environment';

export class ProductTimeSpan {
  label: string;
  amount: number;
  timeSpan: number;
  isCapacityAvailable = true;

  constructor(timeSpan: number,
    isCapacityAvailable = true,
    label = 'Minutes',
    amount = 0
  ) {
    this.timeSpan = timeSpan;
    this.isCapacityAvailable = isCapacityAvailable;
    this.label = label;
    this.amount = amount;
  }

  get available(): string {
    return this.isCapacityAvailable ? 'available' : 'booked up';
  }

  get footer(): string {
    return this.isCapacityAvailable ? environment.globalSettings.toMoneyStr(this.amount) : 'booked up';
  }
}
